Alerts = require 'app/scripts/views/lib/alerts'
Auth = require 'app/scripts/db/auth'
Controller = require 'app/scripts/controller'
View = require 'app/scripts/views/internal/view'
_ = require 'underscore'
t = require('app/scripts/views/internal/teacup-with-helpers')('onboarding')
$ = require 'jquery'
React = require 'react'
ReactDOM = require 'react-dom'
CreateFirstBoardComponent = require 'app/scripts/views/onboarding/create-first-board'

module.exports = class CreateFirstBoardView extends View
  tagName: 'div'
  className: 'first-board-wrapper'

  render: ->
    @$el.html(t.renderable => t.div '.first-board-wrapper.js-create-first-board')

    ReactDOM.render(
      React.createElement(CreateFirstBoardComponent, {
        onSubmit: (board) => @createBoard(board)
      }),
      @$('.js-create-first-board')[0]
    )

    @

  createCollection: (inputs, collection, [attrs]...) ->
    inputs
      .filter (d) => d.name != ''
      .map ({ name }, index) =>
       collection.create(Object.assign({
         name: name
         pos: index + 1
         creationMethod: 'assisted'
       }, attrs))

  createBoard: (board) ->
    initialData = { name: board.name }
    requestData = _.extend({
      prefs_permissionLevel: 'private'
      prefs_selfJoin: true
      prefs_background: 'lime'
      creationMethod: 'assisted'
      defaultLists: false
    }, initialData)

    newBoard = Auth.me().boardList.create initialData, {
      requestData: requestData
      success: (board) =>
        # this fixes an issue with idBoards not being updated at the time that
        # the board gets rendered and the client thinking the member is not on
        # the board
        if board.id !in (currentBoards = Auth.me().get('idBoards'))
          Auth.me().set('idBoards', currentBoards.concat(board.id))
      error: =>
        Alerts.flash('could not create board', 'error', 'create error')
    }

    @listenTo @model.boardList, 'sync', =>
      listInputs = board.lists
      newLists = @createCollection(board.lists, newBoard.listList)
      @listenTo newLists[0], 'sync', =>
        newCards = @createCollection(board.lists[0].cards, newLists[0].cardList)
        checklistInput = board.checkItem
        if _.isEmpty checklistInput
          @navigateToNewBoard(newBoard)
        else
          @listenTo newCards[0], 'sync', =>
            checklist = @createCollection(['Checklist'], newCards[0].checklistList, { idCard: newCards[0].id })[0]
            @listenTo checklist, 'sync', =>
              checkItem = @createCollection([{ name: checklistInput }], checklist.checkItemList)[0]
              @listenTo checkItem, 'sync', =>
                # if we navigate before the checklist item is synced, you get this weird experience where the
                # item exists on the card, but not yet in the card preview
                @navigateToNewBoard(newBoard)

  navigateToNewBoard: (board) ->
    Auth.me().dismiss('create-first-board')
    Controller.displayBoard({
      idBoard: board.id
      openListComposer: false
      openCardComposerInFirstList: true
    }).done()
